import CancelModalButton from 'components/Custom/CancelModalButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { Col, Input, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import { invalidateCoursesOverview } from 'store/Dashboard/actions'
import ProgressiveButton from 'views/pages/ProgressiveButton'
import CustomModal from '../CustomModal'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'

const styles = {
  fileUploadContainer: {
    display: 'flex',
    alignItems: 'center',
  },

  fileUploadInput: {
    position: 'absolute',
    zIndex: 10,
    opacity: 0,
    width: '100%',
    left: 0,
    height: '43px',
    width: '121px',
  },

  uploadButton: {
    background: '#f1f1f1',
    display: 'inline-block',
  },

  fileName: {
    fontSize: '13px',
    marginLeft: '15px',
  },
}

const UploadVideo = (props) => {
  let language = props.language || {
    courses: {
      contentMandatory: 'Content Mandatory',
      videoRestricted: 'Video Restricted',
    },
  }

  const [originalName, setOriginalName] = useState('No File Chosen')

  const onChange = (event) => {
    const originalNameSplit = event.target.value.split(/(\\|\/)/g)

    setOriginalName(originalNameSplit[originalNameSplit.length - 1])
  }
  return (
    <form
      onSubmit={(e) => {
        props.uploadVideo(e, props.handleCloseModal)
      }}
      id='upload-video'
    >
      <div className='row'>
        <div className='col-md-6 title-container'>
          <div>
            <Input
              type='text'
              name='title'
              placeholder={language.settings?.title}
              autoFocus
              value={props.title ? props.title : ''}
              onChange={(event) => props.onChangeTitleText(event.target.value)}
              required
            />
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-12'>
          <div className='upload-video-form-row'>
            <div style={styles.fileUploadContainer}>
              <span
                className='btn btn-disabled px-3 py-1 mt-1'
                style={styles.uploadButton}
              >
                {language.general ? language.general.choose_file : null}
              </span>
              <input
                onChange={onChange}
                style={styles.fileUploadInput}
                type='file'
                name='file'
                required
              />
              <span
                className='text-darker h6 pt-1 pb-0 mb-0'
                style={styles.fileName}
              >
                {originalName}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className='custom-control custom-checkbox-info mt-2'>
        <input
          className='custom-control-input'
          id='required_content'
          type='checkbox'
          checked={props.requiredContent}
          onChange={props.setRequired}
        />
        <label
          className='custom-control-label '
          htmlFor='required_content'
          style={{ fontSize: '14px', paddingTop: '2px' }}
        >
          {language?.courses?.required}
        </label>

        <div>
          <input
            className='custom-control-input'
            id='restrict_video'
            type='checkbox'
            value='restrict_video'
            checked={props.restricVideo}
            onChange={props.setRestrictVideo}
          />

          <label
            className='custom-control-label'
            htmlFor='restrict_video'
            for='restrict_video'
            style={{ fontSize: '14px', paddingTop: '2px' }}
          >
            Restrict video
          </label>
        </div>
      </div>

      <div className='col px-0 position-absolute bottom-3'>
        <ProgressiveButton
          percent={props.uploadVideoPercent}
          status={props.uploadVideoStatus}
          placeholder={language.general ? language.general.submit : null}
          language={props.language}
          form='upload-video'
        />
        <Link to={`/course/${props.course_id}/edit`} type='button'>
          <CancelModalButton
            text={language.general ? language.general.cancel : null}
            customFn={() => props.toggleUploadPage(false)}
          />
        </Link>
      </div>
    </form>
  )
}

const URLVideo = (props) => {
  const dispatch = useDispatch()
  let language = props.language || {}

  return (
    <form
      onSubmit={(e) => {
        props.addUrlVideo(e, props.handleCloseModal)
      }}
      id='url-video'
    >
      <div className='row'>
        <div className='col-md-6 title-container'>
          <Input
            type='text'
            name='title'
            placeholder={language.settings?.title}
            autoFocus
            value={props.title ? props.title : ''}
            onChange={(event) => props.onChangeTitleText(event.target.value)}
            required
          />
        </div>
      </div>
      <div className={`row mt-2 ${props.directUrl ? 'mb-2' : ''}`}>
        <div className='col-6'>
          <Input
            placeholder={props.directUrl ? 'YouTube, Vimeo:' : 'URL:'}
            type='text'
            name='url'
            required
          />
        </div>
      </div>
      {!props.directUrl ? (
        <div className='row'>
          <div className='col-12'>
            <div style={{ fontSize: '11px', color: '#b7b1b1' }}>
              https://vimeo.com/215469361
            </div>
          </div>
        </div>
      ) : null}
      <div className='custom-control custom-checkbox-info my-2'>
        <input
          className='custom-control-input'
          id='required_content'
          type='checkbox'
          checked={props.requiredContent}
          onChange={props.setRequired}
        />
        <label
          className='custom-control-label '
          htmlFor='required_content'
          style={{ fontSize: '14px', paddingTop: '2px' }}
        >
          {language?.courses?.required}
        </label>
      </div>
      <div className='col px-0 position-absolute bottom-3 '>
        {/* <button
          form='url-video'
          className='btn btn-info  progressive-button-container'
        >
          <span className='upload-video-text progressive-button-text'>
            {language.general ? language.general.submit : null}
          </span>
					
        </button> */}
        <SubmitModalButton
          form='url-video'
          text={language.general ? language.general.submit : null}
        />
        <Link to={`/course/${props.course_id}/edit`} type='button'>
          <CancelModalButton
            text={language.general ? language.general.cancel : null}
            customFn={() => props.toggleUploadPage(false)}
          />
        </Link>
      </div>
    </form>
  )
}

function AddVideo(props) {
  const [showModal, setShowModal] = useState(true)
  const history = useHistory()
  const handleCloseModal = () => setShowModal(false)

  useEffect(() => {
    props.selectVideo('upload')

    if (!showModal) {
      history.push(`/course/${props.course_id}/edit`)
    }

    props.onChangeTitleText('')
  }, [showModal])

  // useEffect(() => {
  // 	if (!props.showUploadVideoPage) {
  // 		history.push(`/course/${props.course_id}/edit`)
  // 	}
  // 	props.onChangeTitleText('')
  // }, [props.showUploadVideoPage])
  const [activeSelection, setActiveSelection] = useState('upload')

  const handleSelection = (selection) => {
    setActiveSelection(selection)
    props.selectVideo(selection) // Call the parent function with the selected value
  }

  const isActive = (selection) => activeSelection === selection

  let language = props.language || {}

  return (
    <Modal
      isOpen={showModal}
      toggle={handleCloseModal}
      centered
      size='lg'
      enforceFocus={false}
    >
      <ModalHeader className='py-2 border-bottom' toggle={handleCloseModal}>
        <h3 className='py-2'>Add Video</h3>
        {/* <CardHeader> */}
        <Row>
          <Col className='video-selector d-flex align-items-center add-video-header bg-header p1 '>
            <span onClick={() => handleSelection('upload')}>
              <h4
                className={`border-light ${
                  isActive('upload') ? 'bg-white' : ''
                } pl-2 pr-3`}
              >
                Upload
              </h4>
            </span>
            <span onClick={() => handleSelection('url')}>
              <h4
                className={`border-light ${
                  isActive('url') ? 'bg-white' : 'px-3'
                }`}
              >
                Url
              </h4>
            </span>
            <span onClick={() => handleSelection('direct-url')}>
              <h4
                className={`border-light ${
                  isActive('direct-url') ? 'bg-white' : 'px-3'
                }`}
              >
                Youtube, Vimeo
              </h4>
            </span>
          </Col>
        </Row>
      </ModalHeader>
      <ModalBody style={{ overflow: 'hidden' }}>
        {(() => {
          switch (true) {
            case props.videoType === 'upload':
              return (
                <UploadVideo {...props} handleCloseModal={handleCloseModal} />
              )
            case props.videoType === 'url':
              return <URLVideo {...props} handleCloseModal={handleCloseModal} />
            case props.videoType === 'direct-url':
              return (
                <URLVideo
                  {...props}
                  handleCloseModal={handleCloseModal}
                  directUrl
                />
              )
            default:
              return null
          }
        })()}
        <div className='pb-6'></div>
      </ModalBody>
    </Modal>
  )
}

export default AddVideo
